import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Settings';

const t = i18n(keyset);

export enum DeviceLinkingServerError {
    INVALID_ID = 'Invalid device id',
    NOT_FOUND = 'Model not found',
    ALREADY_ADDED = 'Device already added to this skill',
    OSKU_NOT_FOUND = 'OSKU not found',
}

export enum DeviceLinkingError {
    NOT_FOUND,
    DUPLICATE,
    UNKNOWN,
    INVALID,
}

export const getDeviceLinkingErrorMessage = (code?: DeviceLinkingError) => {
    if (code === undefined) {
        return '';
    }

    switch (code) {
        case DeviceLinkingError.NOT_FOUND:
            return t('devices-error-not_found');
        case DeviceLinkingError.DUPLICATE:
            return t('devices-error-duplicate');
        case DeviceLinkingError.INVALID:
            return t('devices-error-invalid');
        default:
            return t('devices-error-default');
    }
};
